// extracted by mini-css-extract-plugin
export default {"COLOR_MAIN":"#475a3e","COLOR_SPLASH":"#93accd"};